<div class="item-data">
    @if (paymentCart.hawb) {
        <div class="hawb-section d-flex">
            @if (isDuplicated) {
                <mat-icon
                    color="accent"
                    class="material-symbols-outlined md-icon-18 overflow-visible"
                    [attr.aria-label]="'Duplicated HAWB warning'"
                    role="img"
                >
                    warning_amber
                </mat-icon>
            }
            <div class="mat-caption item-data__title">
                HAWB:
                <span class="text-break item-data__value">{{ paymentCart.hawb }}</span>
            </div>
        </div>
    }

    <div class="payment-type-section d-flex">
        @if (isDuplicated && !paymentCart.hawb) {
            <mat-icon
                color="accent"
                class="material-symbols-outlined md-icon-18 overflow-visible"
                [attr.aria-label]="'Duplicated payment type warning'"
                role="img"
            >
                warning_amber
            </mat-icon>
        }
        <div class="mat-caption item-data__title">
            Payment type:
            <span class="text-break item-data__value">{{ paymentCart.externalData?.paymentType }}</span>
        </div>
    </div>

    @if (quantity && calculateQuantityByExtraItems) {
        <div class="quantity-section">
            <div class="mat-caption item-data__title">
                Quantity:
                <span class="text-break item-data__value">{{ quantity }}</span>
            </div>
        </div>
    }
</div>
